export default "/images/gefera-whooise.png?84226eb2dddde2bf31d87f607a873ada";